import { setupEmbeddedContent } from 'common/utils/embed';

setupEmbeddedContent(true);
